import React from "react";
import {Toolbar} from "visuaui";
import {Link, Route, useRouteMatch} from "react-router-dom";
import {
    Container,
    Tabs,
    Tab,
    Box,
} from "@mui/material";
import PipelineTab from "./pipeline/pipeline-tab";
import BreakoutContainer from "./breakout-container";
import ClientFeedbackContainer from "./pipeline/client-feedback-container";
import ClientFeedbackDetail from "./pipeline/client-feedback-detail";

const OPTIONS = [
    { path: 'progress',        label: 'progress' },
    { path: 'complete',        label: 'complete' },
    { path: 'archived',        label: 'archived' },
    { path: 'breakout',        label: 'breakout' },
    { path: 'logo-audit', label: 'Logo Audit' },
]

export default function PipelineContainer() {
    let { url } = useRouteMatch();
    const pipelineTabs = OPTIONS.map(({ path, label }) => (
        <Tab
            key={path}
            label={label}
            component={Link}
            to={`${url}/${path}`}
            value={`${url}/${path}`}
            sx={{
                "&.Mui-selected": {
                    fontWeight: 'bold !important',
                }
            }}
        />
    ))

    return (
        <>
            <Toolbar>
                <Route
                    path="/"
                    render={({location}) => {
                        // Keep the logo-audit tab highlighted when on a detail sub-route
                        const pathname = location.pathname;
                        const logoAuditBase = `${url}/logo-audit`;
                        const tabValue = pathname.startsWith(logoAuditBase) ? logoAuditBase : pathname;
                        return (
                            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                                <Tabs value={tabValue}>
                                    {pipelineTabs}
                                </Tabs>
                            </Box>
                        );
                    }}
                />
            </Toolbar>
                <Route
                    path={`${url}/progress`}
                    render={() => <PipelineTab type={1}/>}
                />
                <Route
                    path={`${url}/complete`}
                    render={() => <PipelineTab type={2} />}
                />
                <Route
                    path={`${url}/archived`}
                    render={() => <PipelineTab type={3} />}
                />
            <Route
                path={`${url}/breakout`}
                render={() => <BreakoutContainer  />}
            />
            <Route
                exact
                path={`${url}/logo-audit`}
                render={() => <ClientFeedbackContainer />}
            />
            <Route
                path={`${url}/logo-audit/:groupHash`}
                render={() => <ClientFeedbackDetail />}
            />
        </>
    )
}
